module.exports = "/static/assets/61ba3c80aed48940e6a4a699f1f2f6e6.gif";